export const GET_CAMERAS = "GET_CAMERAS";
export const CREATE_OR_UPDATE_CAMERA = "CREATE_OR_UPDATE_CAMERA";
export const GET_CAMERA_HISTORIES = "GET_CAMERA_HISTORIES";
